import { RouteValidatorService } from '@/app/services/route-validator.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Input,
  Output,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-share-modal',
  standalone: true,
  imports: [RouterLink, CommonModule, TranslateModule],
  templateUrl: './share-modal.component.html',
  styleUrl: './share-modal.component.scss',
})
export class ShareModalComponent {
  private routeValidatorService = inject(RouteValidatorService);

  onlyShowToritoPage = computed(() =>
    this.routeValidatorService.onlyShowToritoPage()
  );

  urlIcon = environment.urlIcon;
  @Input() link = environment.urlApp;
  isCopied = false;

  productIdByTorito = input('');

  @Output() onClose = new EventEmitter<void>();

  descriptionMessage = computed(() => {
    if (this.onlyShowToritoPage()) {
      return `Resultado de ${this.productIdByTorito()}.`;
    }

    return `Check this out! `;
  });

  constructor(private clipboard: Clipboard, private toastr: ToastrService) {}

  copy() {
    this.isCopied = true;
    this.clipboard.copy(this.link);
    // this.toastr.success('Link Copied', 'Success');
  }

  closeModal() {
    this.onClose.emit();
  }
  shareOnPlatform(platform: string) {
    let shareUrl = '';

    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.link}`;
        break;
      case 'email':
        shareUrl = `mailto:?subject=${this.descriptionMessage()}&body=${
          this.link
        }`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${
          this.link
        }&text=${this.descriptionMessage()}`;
        break;
      case 'google':
        shareUrl = `https://plus.google.com/share?url=${this.link}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${this.link}`;
        break;
      case 'pinterest':
        shareUrl = `https://pinterest.com/pin/create/button/?url=${
          this.link
        }&description=${this.descriptionMessage()}`;
        break;
      case 'instagram':
        shareUrl = `https://www.instagram.com/?url=${this.link}`;
        break;
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${this.descriptionMessage()} ${
          this.link
        }`;
        break;
      case 'telegram':
        shareUrl = `https://t.me/share/url?url=${
          this.link
        }&text=${this.descriptionMessage()}`;
        break;
      default:
        console.error(`Unknown platform: ${platform}`);
        return;
    }

    window.open(shareUrl, '_blank');
  }
}
